import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WorkbenchModule } from '@workbench/angular';
import { TranslationService } from '../../../services/translation.service';
import { CountrySelectionService } from '../../../services/country-selection/country-selection.service';


@Component({
    selector: 'app-country-selector',
    standalone: true,
    imports: [WorkbenchModule, TranslateModule],
    templateUrl: './country-selector.component.html',
    styleUrl: './country-selector.component.scss',
})
export class CountrySelectorComponent implements OnInit {


    public countryList: any[] = [{ title: '', code: '' }];
    public hasUserConfirmedCountry: boolean = false;
    public userOriginCountry = '';
    isSelectedCountrySupported: boolean = false;
    isLoginRedirectionInProgress: boolean = false;

    @ViewChild('imageBackground') imageBackground: ElementRef | undefined;
    constructor(private readonly _countrySelectionService: CountrySelectionService, private readonly _translationService: TranslationService ) { }

    ngOnInit(): void {
        if (localStorage.getItem('countryOfOrigin')) {
            return;
        }
        this.countryList = this._translationService.cpConfig.countries
            .map((country: any) => {
                return {
                    title: country.name,
                    code: country.code,
                    region: country.region,
                    isSupported: country.flag
                };
            });
    }

    selectCountry(e: any): void {
        this.isLoginRedirectionInProgress = false
        this.isSelectedCountrySupported = false;
        this.userOriginCountry = e?.detail?.value?.label;
        const selectedCountryDetails = this.countryList.find((country: any) => country.title === this.userOriginCountry)
        if (!selectedCountryDetails) {
            this.isSelectedCountrySupported = false
            return;
        }
        if (!selectedCountryDetails?.isSupported) {
                    this.isSelectedCountrySupported = true
        }

        // Simulating a click event because the dropdown won't close otherwise
        setTimeout(() => {
            this.imageBackground?.nativeElement.click();
        }, 100);
    }

    onInputCountryChange(event: any) {
        if (event?.detail?.value === '') {
            this.userOriginCountry = '';
        }
    }

    onCheckBoxSelect(e: any) {
        this.hasUserConfirmedCountry = e?.detail?.checked;
    }

    onCountrySelectClick() {
        this.isLoginRedirectionInProgress = true;
        if (this.userOriginCountry && this.userOriginCountry !== '' && this.hasUserConfirmedCountry) {
            const countryDetails = this.countryList.find(country => country.title === this.userOriginCountry);
            this._countrySelectionService.setCountry(JSON.stringify(countryDetails))
        }
    }
}
